import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';

export const loginUrlMap = {
  getClusters: () => `${PREFIX.vapis(GROUPS.iam)}/yourselfdatacenters`,
  getClusters1: (tenant) => {
    if (tenant) return `${PREFIX.vapis_ws(GROUPS.workspace, tenant)}/datacenters`;
    return `${PREFIX.vapis_ws(GROUPS.workspace)}/datacenters`;
  },
  // 未登录获取数据中心列表
  getClustersNoLogin: () => `${PREFIX.oauth}/datacenters`,
};

export function getTenantClusters(params?: any, tenant?: string) {
  if (params?.modules) {
    params.module = params.modules;
    delete params.modules;
  }
  return get(`${loginUrlMap.getClusters1(tenant)}`, params, { flag: true });
}

export function getClusters(params?: any): Promise<any> {
  return get<any>(`${loginUrlMap.getClusters()}`, params);
}

export async function getClustersNoLogin(params?: any): Promise<any> {
  const data = await get<{ items: any[]; totalItems: number }>(`${loginUrlMap.getClustersNoLogin()}`, params);
  return data.items || [];
}

export function getBindingworkspaces(cluster?, params?: any) {
  return get(`${PREFIX.vapis_dc(GROUPS.datacenter)}/workspaces`, params);
}
